const ADVISOR_SUPPORT_EMAIL = "support@earned.com";
export { ADVISOR_SUPPORT_EMAIL };
